/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowMuralPaintingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowMuralPaintingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Create a Mural Together!",
    "Mural Painting Workshop Awaits!",
    "Express Yourself on the Wall!",
  ],
  title: "Mural Painting Workshop",
  description: "Organize a fun mural painting workshop.",
  longDescription:
    "Gather your friends for an exciting mural painting workshop! Choose a date, decide on themes, and plan materials needed!",
  emoji: "🎨",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Mural Painting Workshop",
          emoji: "🎨",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the mural painting workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on mural themes?",
            description: "What themes should we explore during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What themes should we consider?",
                emoji: "🖌",
                completeAction: {
                  question: "Decide on colors and materials needed?",
                  description:
                    "What colors and materials should we gather for the mural?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What colors and materials should we bring?",
                      emoji: "🌈",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Art on the Walls!",
    outroDescription:
      "Your mural painting workshop plans are set! Enjoy the creativity!",
  },
};
